document.querySelectorAll('.show_popup .btn, .header_btn, footer .btn, .nav-Contact a, .nav-Catalog a, .footer__links .contact, .footer__links .catalog, .drawer-menu__item .contact, .drawer-menu__item .faqs, .drawer-menu__item .catalog').forEach(function(button) {
  button.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation(); // 👈 stops event from bubbling up
    document.querySelectorAll('.popup_wrapper').forEach(function(popup) {
      popup.classList.remove('hide_popup');
      document.body.classList.add('popup_active');
    });
  });
});

document.querySelectorAll('.popup_wrapper .popup_close').forEach(function(button) {
  button.addEventListener('click', function() {
    document.querySelectorAll('.popup_wrapper').forEach(function(popup) {
      popup.classList.add('hide_popup');
      document.body.classList.remove('popup_active');
    });
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".cone_section");
  if (!section) return;

  const listItems = section.querySelectorAll("li");
  if (listItems.length === 0) return;

  function updateActiveItems() {
    const rect = section.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Section fully below viewport → reset
    if (rect.top > windowHeight * 0.8) {
      listItems.forEach((li) => li.classList.remove("active"));
      return;
    }

    // Section scrolled past 20% out of view → keep all active
    if (rect.bottom < windowHeight * 0.2) {
      listItems.forEach((li) => li.classList.add("active"));
      return;
    }

    // Section in view → activate items based on progress
    const sectionHeight = rect.height;
    const visible = windowHeight - rect.top;
    const progress = Math.min(Math.max(visible / sectionHeight, 0), 1);

    // Slightly slowed down but still snappy
    const activeCount = Math.ceil(progress * (listItems.length * 0.8));

    listItems.forEach((li, i) => {
      li.classList.toggle("active", i < activeCount);
    });
  }

  window.addEventListener("scroll", updateActiveItems);
  window.addEventListener("resize", updateActiveItems);
  updateActiveItems();
});
